import { render, staticRenderFns } from "./UpdateConfigType.vue?vue&type=template&id=0d73011b&scoped=true"
import script from "./UpdateConfigType.vue?vue&type=script&lang=js"
export * from "./UpdateConfigType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d73011b",
  null
  
)

export default component.exports